import { lazyLoadPage } from 'common/utils/lazyLoad';

export const ErrorPageLazy = lazyLoadPage(() =>
  import(/* webpackChunkName: "ErrorPage" */ './ErrorPageContent').then((r) => r.ErrorPageContent),
);
